// extracted by mini-css-extract-plugin
module.exports = {"statBadge":"ImageResources_statBadge__drJ_Q"};